import * as actionTypes from './actionTypes';
import axios from '../../axios-orders';

export const addIngredient = (name) => {
    return {
        type: actionTypes.ADD_INRGEDIENTS,
        payload: name
    };
};

export const removeIngredient = (name) => {
    return {
        type: actionTypes.REMOVE_INRGEDIENTS,
        payload: name
    };
};

export const setIngredients = (ingredients) => {
    return {
        type: actionTypes.SET_INGREDIENTS,
        payload: ingredients
    };
};

export const fetchIngredientsFailed = () => {
    return {
        type: actionTypes.FETCH_INGREDIENTS_FAILED
    };
};


export const initIngredients = () => {
    return dispatch => {
        axios.get('https://myburger-d74db.firebaseio.com/ingredients.json')
            .then(response => {
                dispatch(setIngredients(response.data));
            })
            .catch(error => {
                dispatch(fetchIngredientsFailed());
            });
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/burgerBuilder.js